import { render, staticRenderFns } from "./ApplicationConsents.vue?vue&type=template&id=29a0de8b&scoped=true&"
import script from "./ApplicationConsents.vue?vue&type=script&lang=js&"
export * from "./ApplicationConsents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a0de8b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/projects/tus-cc-auth/tus-cc-auth/frontend/tusauth/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
installComponents(component, {VBtn,VCheckbox})
